import { SeedingStrategy } from "features/WorklistTools/shared/interfaces";
import {
  ExternalThawInternalAction,
  IExternalThawInternalAction,
} from "./actions";
import { IExternalThawInternalState } from "./initial-state";

export function ExternalThawInternalReducer(
  state: IExternalThawInternalState,
  action: IExternalThawInternalAction
) {
  switch (action.type) {
    case ExternalThawInternalAction.SET_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    case ExternalThawInternalAction.SET_DEST_SELECTION_PROCESS:
      return {
        ...state,
        destSelectionProcess: action.payload.destSelectionProcess,
      };
    case ExternalThawInternalAction.SET_RANDOMIZE_WELLS:
      return {
        ...state,
        randomizeWells: action.payload.randomizeWells,
      };
    case ExternalThawInternalAction.SET_SELECTED_SOURCE_WELLS:
      return {
        ...state,
        selectedSourceWells: action.payload.selectedSourceWells,
      };
    case ExternalThawInternalAction.SET_SELECTED_INTERMEDIATE_WELLS:
      return {
        ...state,
        selectedIntToDestWells: action.payload.selectedIntermediateWells,
      };
    case ExternalThawInternalAction.SET_SELECTED_INT1_WELLS:
      return {
        ...state,
        selectedInt1Wells: action.payload.selectedInt1Wells,
      };
    case ExternalThawInternalAction.SET_HOVER_WELL_ID:
      return {
        ...state,
        hoverWellId: action.payload.hoverWellId,
      };
    case ExternalThawInternalAction.SET_NEXT_STEP:
      return {
        ...state,
        step: state.step + 1,
      };
    case ExternalThawInternalAction.SET_PREV_STEP:
      return {
        ...state,
        step: state.step - 1,
      };
    case ExternalThawInternalAction.SET_SELECTED_DESTINATION_INDEX:
      return {
        ...state,
        selectedDestinationIndex: action.payload.selectedDestinationIndex,
      };
    case ExternalThawInternalAction.SET_REQUIRED_WARNINGS:
      return {
        ...state,
        requiredWarnings: action.payload.requiredWarnings,
      };
    case ExternalThawInternalAction.SET_OPTIONAL_WARNINGS:
      return {
        ...state,
        optionalWarnings: action.payload.optionalWarnings,
      };
    case ExternalThawInternalAction.SET_WORKLIST:
      return {
        ...state,
        worklist: action.payload.worklist,
        worklistPreviewOpen: action.payload.worklistPreviewOpen,
      };
    case ExternalThawInternalAction.SET_WORKLIST_PREVIEW_OPEN:
      return {
        ...state,
        worklistPreviewOpen: action.payload.worklistPreviewOpen,
      };
    case ExternalThawInternalAction.SET_PLATE_HAS_TUBE_BARCODE_SCAN:
      return {
        ...state,
        sourcePlateHasTubeBarcodeScan:
          action.payload.sourcePlateHasTubeBarcodeScan,
      };
    case ExternalThawInternalAction.UPDATE_METHOD_SETTINGS:
      return {
        ...state,
        methodSettings: {
          ...state.methodSettings,
          [action.payload.key]: action.payload.value,
        },
      };
    case ExternalThawInternalAction.UPDATE_STAMP_ROWCOLVOL:
      return {
        ...state,
        methodSettings: {
          ...state.methodSettings,
          ...action.payload,
        },
      };
    case ExternalThawInternalAction.UPDATE_METHOD_SETTINGS_BY_TEMPLATE:
      return {
        ...state,
        methodSettings: action.payload.methodSettings,
      };
    case ExternalThawInternalAction.SET_SEEDING_STRATEGY: {
      if (action.payload.seedingStrategy === SeedingStrategy.CellCount) {
        return {
          ...state,
          methodSettings: {
            ...state.methodSettings,
            seedingStrategy: action.payload.seedingStrategy,
            splitSeedingVolEvenly: false,
          },
        };
      }
      return {
        ...state,
        methodSettings: {
          ...state.methodSettings,
          seedingStrategy: action.payload.seedingStrategy,
          splitSeedingVolEvenly: true,
        },
      };
    }
    case ExternalThawInternalAction.SET_SPLIT_SEEDING_VOL_EVENLY:
      return {
        ...state,
        methodSettings: {
          ...state.methodSettings,
          splitSeedingVolEvenly: action.payload.splitSeedingVolEvenly,
        },
      };

    case ExternalThawInternalAction.SET_INCUBATION_TIME:
      return {
        ...state,
        methodSettings: {
          ...state.methodSettings,
          incubationTime: action.payload.incubationTime,
        },
      };

    case ExternalThawInternalAction.SET_EXPERIMENT_SETTINGS:
      return {
        ...state,
        methodSettings: {
          ...state.methodSettings,
          experimentSettings: action.payload.experimentSettings,
        },
      };
  }
}
